import Cookies from 'js-cookie';
import { LOGIN_FLAG_COOKIE_NAME } from '@immediate_media/auth-constants';

const getIsLoggedIn = () => Cookies.get(LOGIN_FLAG_COOKIE_NAME) === '1';

export default getIsLoggedIn;
